import React from "react";
import styles from './TodoItem.module.css';

function TodoItem({ task, index, toggleComplete, deleteTask }) {
  return (
    
    <tr className={task.completed ? "completed" : ""}>
      <td>{index + 1}</td>
      <td onClick={() => toggleComplete(index)}>{task.title}</td>
      <td>{task.description}</td>
      <td>{task.deadline}</td>
      <td>
        <button onClick={() => deleteTask(index)}>Delete</button>
      </td>
    </tr>
  );
}

export default TodoItem;
